import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "material-icons mr-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-challenge"
}
const _hoisted_3 = {
  key: 1,
  class: "text-gray-500 dark:text-dark-text"
}
const _hoisted_4 = { class: "border rounded text-xs p-1 mr-4 text-challenge border-challenge" }
const _hoisted_5 = { class: "text-2xl font-bold mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "hover-hand border rounded flex items-center px-4 py-3 my-1 hover:shadow transition duration-150 hover:border-challenge dark:hover:border-challenge text-gray-900 dark:border-dark-400 dark:text-dark-text dark:bg-dark-500",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("span", _hoisted_1, [
      (_ctx.problem.isSolved)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " check_circle "))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, " radio_button_unchecked "))
    ]),
    _createElementVNode("span", _hoisted_4, " Day " + _toDisplayString(_ctx.day), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.problem.name), 1)
  ]))
}